import { Box, Flex, Loading, Text } from '@shared/components';

import {
  RandomConfigInformation,
  type RandomConfigInformationProps,
} from '../random-config-information';
import { TimeLimitInformation, type TimeLimitInformationProps } from '../time-limit-information';

export interface QConfigSummaryDetailsContentProps {
  loading: boolean;
  timeLimits: TimeLimitInformationProps['timeLimits'];
  randomConfigType: RandomConfigInformationProps['randomConfigType'];
}

export default function QConfigSummaryDetailsContent(
  props: Readonly<QConfigSummaryDetailsContentProps>,
) {
  const { loading: isLoading, timeLimits, randomConfigType } = props;

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text sx={{ flexBasis: '160px' }} variant='body1Semibold'>
          ระยะเวลาทำข้อสอบ:
        </Text>
        <Box sx={{ flex: 1 }}>
          <TimeLimitInformation timeLimits={timeLimits} />
        </Box>
      </Flex>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text sx={{ flexBasis: '160px' }} variant='body1Semibold'>
          รูปแบบการสุ่มคำถาม:
        </Text>
        <RandomConfigInformation sx={{ flex: 1 }} randomConfigType={randomConfigType} />
      </Flex>
    </>
  );
}
